import { render, staticRenderFns } from "./IcnNote.vue?vue&type=template&id=b33b13ec&scoped=true"
import script from "./IcnNote.vue?vue&type=script&lang=js"
export * from "./IcnNote.vue?vue&type=script&lang=js"
import style0 from "./IcnNote.vue?vue&type=style&index=0&id=b33b13ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33b13ec",
  null
  
)

export default component.exports